  /*================ Eligible Vehicles Factory
  ========================================*/

  // Should separate it in two factories.
  angular
    .module('vppApp')
    .factory('EligibleVehiclesFactory', EligibleVehiclesFactory);

    EligibleVehiclesFactory.$inject = ['$http', '$rootScope'];

    function EligibleVehiclesFactory($http, $rootScope){
      
      var eligibleVehiclesAllowanceInfo = {

        getRedemptionAllowance : function(){
          var year = "2016";
          var accountId = AccountService.loadAccountId();
          return $http(
            {
            url: '/content/json/eligibleVehicles/redemption-allowances.json',
            method: "GET"
          })
          .then(function (response) {
            return response.data;
          });
        },

        getVehicleLinks : function(){
          var Url  ="/content/json/eligibleVehicles/vehicle-links.json";
          var promise = $http.get(Url).then(function(response){
            return response.data;
          });
          return promise;
        }
      };
      return eligibleVehiclesAllowanceInfo;
  };
